var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { UuiTab, UuiTabs, UuiTabPanel } from '@aonunited/react';
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = __rest(props, ["children", "value", "index"]);
    return (React.createElement("div", __assign({ role: "tabpanel", hidden: value !== index, id: "full-width-tabpanel-".concat(index), "aria-labelledby": "full-width-tab-".concat(index) }, other), value === index && (React.createElement(Box, { sx: { p: 3 } },
        React.createElement(Typography, null, children)))));
}
function a11yProps(index) {
    return {
        id: "full-width-tab-".concat(index),
        'aria-controls': "full-width-tabpanel-".concat(index),
    };
}
export default function ClientTab(props) {
    var _a = React.useState(1), activeTab = _a[0], setActiveTab = _a[1];
    React.useEffect(function () {
        //reload the page
    }, [activeTab]);
    // Carrier Matrix clients hide the Client Staff/AON staff subtabs - fall back to
    // Current Market List if a previously selected client had one of those tabs active.
    React.useEffect(function () {
        if (props.hideStaffTabs && activeTab !== 1) {
            setActiveTab(1);
        }
    }, [props.hideStaffTabs]);
    var ElementOne = React.useMemo(function () {
        return React.createElement(props.elementOne, { activeTab: activeTab, selectedClientGuuid: props.selectedClientGuuid });
    }, [activeTab, props.selectedClientGuuid]);
    var ElementTwo = React.useMemo(function () {
        return React.createElement(props.elementTwo, { activeTab: activeTab, selectedClientGuuid: props.selectedClientGuuid });
    }, [activeTab, props.selectedClientGuuid]);
    var ElementThree = React.useMemo(function () {
        return React.createElement(props.elementThree, { activeTab: activeTab, selectedClientGuuid: props.selectedClientGuuid });
    }, [activeTab, props.selectedClientGuuid]);
    var handleChange = function (_activeTab) {
        setActiveTab(_activeTab);
    };
    return (React.createElement("div", null,
        React.createElement("div", { style: { padding: "10px,10px,10px,30px" } },
            React.createElement(UuiTabs, { fillevenly: true, style: { Height: "500px" } },
                React.createElement(UuiTab, { active: activeTab === 1, tabIndex: 1, onClick: function () { return handleChange(1); } }, "Current Market List"),
                !props.hideStaffTabs && React.createElement(UuiTab, { active: activeTab === 2, tabIndex: 2, onClick: function () { return handleChange(2); } }, "Client Staff"),
                !props.hideStaffTabs && React.createElement(UuiTab, { active: activeTab === 3, tabIndex: 3, onClick: function () { return handleChange(3); } }, "AON staff"))),
        React.createElement(UuiTabPanel, { activeindex: activeTab, index: 1 }, ElementOne),
        !props.hideStaffTabs && React.createElement(UuiTabPanel, { activeindex: activeTab, index: 2 }, ElementTwo),
        !props.hideStaffTabs && React.createElement(UuiTabPanel, { activeindex: activeTab, index: 3 }, ElementThree)));
}
